import { createAction } from '@reduxjs/toolkit'

import type { TSimChatDto, TSimChatsDto } from '@homepal/api-contract'

/**
 * `requestKey` is the filter a list request was made for, serialized. It
 * travels on every action so the reducer can tell a response apart from one
 * to an older request with another filter.
 */
// tryGetSimChats
export const getAll = createAction<{ requestKey: string }>(
  'internal_get_sim_chats'
)
export const getAllSuccess = createAction<{
  data: TSimChatsDto
  requestKey: string
}>('internal_get_sim_chats_success')
export const getAllFailed = createAction<{ requestKey: string }>(
  'internal_get_sim_chats_failed'
)

// tryGetSimChat
export const getOne = createAction<{ id: string }>('internal_get_sim_chat')
export const getOneSuccess = createAction<TSimChatDto>(
  'internal_get_sim_chat_success'
)
export const getOneFailed = createAction<{ id: string }>(
  'internal_get_sim_chat_failed'
)
